import React from "react";
import { MapPin, Bookmark, Briefcase, Clock, Zap } from "lucide-react";

const fmtSalary = (a, b) => `$${Math.round(a / 1000)}k – $${Math.round(b / 1000)}k`;

function timeAgo(iso) {
  if (!iso) return "";
  const d = (Date.now() - new Date(iso).getTime()) / 86400000;
  if (d < 1) return "Today";
  if (d < 2) return "1d ago";
  return `${Math.floor(d)}d ago`;
}

export default function JobCard({ job, saved, onToggleSave, onOpen, showDistance }) {
  return (
    <div
      data-testid="job-card-item"
      onClick={() => onOpen(job)}
      className="group cursor-pointer rounded-xl bg-slate-900/70 border border-slate-800 hover:border-teal-500/40 hover:shadow-[0_0_24px_rgba(45,212,191,0.10)] transition-all duration-300 p-5"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-start gap-3 min-w-0">
          <div className="w-11 h-11 shrink-0 rounded-lg bg-gradient-to-br from-slate-700 to-slate-800 border border-slate-700 flex items-center justify-center font-display font-bold text-teal-300">
            {job.company?.[0] || "W"}
          </div>
          <div className="min-w-0">
            <h3 className="font-display font-semibold text-slate-100 text-base leading-tight truncate group-hover:text-teal-300 transition-colors">
              {job.title}
            </h3>
            <p className="text-sm text-slate-400 truncate">{job.company}</p>
          </div>
        </div>
        <button
          data-testid="job-card-bookmark-button"
          onClick={(e) => { e.stopPropagation(); onToggleSave(job); }}
          className={`p-1.5 rounded-lg transition-colors ${saved ? "text-teal-400" : "text-slate-500 hover:text-teal-400"}`}
        >
          <Bookmark size={18} fill={saved ? "currentColor" : "none"} />
        </button>
      </div>

      <div className="flex flex-wrap gap-1.5 mt-4">
        <span className="text-xs px-2.5 py-1 rounded-full bg-slate-800/80 text-cyan-300 border border-cyan-500/20">{job.job_type}</span>
        <span className="text-xs px-2.5 py-1 rounded-full bg-slate-800/80 text-blue-300 border border-blue-500/20">{job.work_mode}</span>
        <span className="text-xs px-2.5 py-1 rounded-full bg-slate-800/80 text-slate-300 border border-slate-700">{job.experience}</span>
        {job.urgent && (
          <span className="text-xs px-2.5 py-1 rounded-full bg-red-500/15 text-red-300 border border-red-500/30 flex items-center gap-1">
            <Zap size={11} /> Urgent
          </span>
        )}
      </div>

      <div className="flex items-center justify-between mt-4 pt-4 border-t border-slate-800">
        <div className="text-teal-300 font-mono text-sm font-semibold">{fmtSalary(job.salary_min, job.salary_max)}</div>
        <div className="flex items-center gap-3 text-xs text-slate-500">
          {showDistance && job.distance_km != null && (
            <span className="flex items-center gap-1 text-teal-400 whitespace-nowrap"><MapPin size={12} /> {job.distance_km} km</span>
          )}
          <span className="hidden sm:flex items-center gap-1 whitespace-nowrap"><MapPin size={12} /> {job.location?.split(",")[0]}</span>
          <span className="flex items-center gap-1 whitespace-nowrap"><Clock size={12} /> {timeAgo(job.posted_at)}</span>
        </div>
      </div>
    </div>
  );
}

export { fmtSalary, timeAgo };
